import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SearchFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.2 3.4C14.14 3.4 17.4 6.64 17.4 10.56C17.4 12.3 16.76 13.92 15.7 15.18L20 19.48L18.68 20.8L14.32 16.44C13.14 17.26 11.72 17.74 10.2 17.74C6.26 17.74 3 14.48 3 10.56C3 6.64 6.26 3.4 10.2 3.4ZM10.2 15.94C13.14 15.94 15.52 13.52 15.52 10.56C15.52 7.62 13.14 5.2 10.2 5.2C7.26 5.2 4.88 7.62 4.88 10.56C4.88 13.52 7.26 15.94 10.2 15.94ZM10.2 14.32C8.16 14.32 6.48 12.62 6.48 10.56C6.48 8.52 8.16 6.82 10.2 6.82C12.24 6.82 13.92 8.52 13.92 10.56C13.92 12.62 12.24 14.32 10.2 14.32Z" />
    </SvgIcon>
  );
});
